import { render, staticRenderFns } from "./SubdirectoryItem.vue?vue&type=template&id=524deec4&scoped=true"
import script from "./SubdirectoryItem.vue?vue&type=script&lang=js"
export * from "./SubdirectoryItem.vue?vue&type=script&lang=js"
import style0 from "./SubdirectoryItem.vue?vue&type=style&index=0&id=524deec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524deec4",
  null
  
)

export default component.exports